import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import { useRef, useState } from 'react';
import {
  useGetUserInfoQuery,
  useSendAccountVerificationLinkMutation,
  useUpdateUserEmailMutation,
  useUpdateUserNameMutation,
} from 'store/services/segmentsApi';
import { usePageTitle } from 'utils';

export default function Settings() {
  usePageTitle('General | Segments');

  const formRef = useRef();
  const [name, setName] = useState('');
  const [newEmail, setNewEmail] = useState('');

  const { data, isFetching } = useGetUserInfoQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const [updateName, { isLoading: updateNameLoading }] =
    useUpdateUserNameMutation();
  const [updateEmail, { isLoading: emailLoading }] =
    useUpdateUserEmailMutation();
  const [sendVerificationLink, { isLoading: sendVerificationLoading }] =
    useSendAccountVerificationLinkMutation();

  const handleSendVerificationLink = () => sendVerificationLink('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (name) {
      updateName({ new_name: name });
    }

    if (newEmail) {
      updateEmail({ new_email: newEmail });
    }
  };

  return (
    <div className="relative max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11 ">
      <div>
        <p className="font-bold">Settings</p>
        <h1 className="font-bold text-segments-44px">Update name / email</h1>
      </div>
      <div className="flex items-center justify-center h-full mt-20">
        <form
          // @ts-ignore
          ref={formRef}
          onSubmit={handleSubmit}
          className="w-full max-w-2xl mt-8"
        >
          <div className="items-center lg:space-x-48 lg:flex">
            <label htmlFor="name" className="block text-base">
              Name
            </label>
            <TextField
              // @ts-ignore
              name="name"
              type="name"
              placeholder={isFetching ? 'Loading...' : data?.name}
              value={name}
              // @ts-ignore
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="items-center mt-4 lg:mt-0 lg:space-x-48 lg:flex">
            <label htmlFor="new_email" className="block text-base">
              Email
            </label>
            <TextField
              // @ts-ignore
              name="new_email"
              type="email"
              placeholder={isFetching ? 'Loading...' : data?.email}
              value={newEmail}
              // @ts-ignore
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
          <div className="flex justify-end mt-4 space-x-5">
            {data?.confirmed ? (
              <p className="px-4 py-2 font-bold text-white rounded-lg bg-segments-accent-green-saved">
                Verified
              </p>
            ) : (
              <>
                <p className="px-4 py-2 font-bold text-white rounded-lg bg-segments-danger">
                  Not verified
                </p>
                <button
                  className="w-56 py-2 font-bold text-white rounded-lg bg-segments-accent-color-1 focus:outline-none"
                  onClick={handleSendVerificationLink}
                >
                  {sendVerificationLoading ? (
                    <SpinnerSmall />
                  ) : (
                    'Resend verification link'
                  )}
                </button>
              </>
            )}
          </div>
          <div className="flex justify-end mt-20">
            <div>
              <ButtonCTA
                variant="main"
                type="submit"
                disabled={!!!name && !!!newEmail}
              >
                <div className="w-40">
                  {updateNameLoading || emailLoading ? (
                    <SpinnerSmall />
                  ) : (
                    'Save changes'
                  )}
                </div>
              </ButtonCTA>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
